import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './ProductsandCoverageSelection.metadata.json5';
import styles from '../../../SpaAndWellCommonStyles.module.scss'

function ProductsandCoverageSelection(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ProductsandCoverageSelection');
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        equBreFie: {
            defaultValue: false,
            visible: _.get(modelVM, 'proReqFie.value.code') === 'SpaWel' && !_.isUndefined(modelVM.proFie.value) && modelVM.proFie.value
        },
        criFie: {
            defaultValue: false,
            visible: _.get(modelVM, 'proReqFie.value.code') === 'SpaWel' && !_.isUndefined(modelVM.proFie.value) && modelVM.proFie.value
        },
        ifYesPleProDetFie: {
            visible: _.get(modelVM, 'hasAnyInsEveCanDecFie.value')
        },
        medMalFie: {
            readOnly: true
        },
        comGenLiaFie: {
            defaultValue: false
        },
        cybLiaFie: {
            defaultValue: false
        },
        proFie: {
            defaultValue: false
        },
        doYouOrAnyLivUndYouRooFie: {
            required: !_.isUndefined(submissionVM.value.baseData.baseState_Ext)
                && _.get(submissionVM.value, 'baseData.baseState_Ext') === 'QC',
            visible: !_.isUndefined(submissionVM.value.baseData.baseState_Ext)
                && _.get(submissionVM.value, 'baseData.baseState_Ext') === 'QC'
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ProductsandCoverageSelection.propTypes = wizardProps;
export default withRouter(ProductsandCoverageSelection);
